import * as yup from 'yup'
import { INVALID_EMAIL, REQUIRED_FIELD } from 'constants/errors'

export const schemaInviteClient = yup.object().shape({
  email: yup.string().required(REQUIRED_FIELD).email(INVALID_EMAIL),
})
